var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"select-actions"},[(_vm.select)?_c('span',[_c('v-layout',[_c('v-row',[_c('v-col',[_c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,false,3221905750)},[_c('v-list',[_c('v-list-item-group',[_c('router-link',{attrs:{"to":{
                    name: 'Select',
                    query: {
                      view: _vm.select.query_id,
                    },
                  }}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',[_vm._v(" mdi-file-find ")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Run Select")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }